export default __webpack_public_path__ + "static/media/link.4f8ad9d7.svg";